{
  "de": {
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Oops, wir konnten Ihre reCAPTCHA-Antwort nicht validieren. Bitte versuchen Sie es erneut.",
        "verification_failed": "Die reCAPTCHA-Überprüfung ist fehlgeschlagen, bitte versuchen Sie es erneut."
      }
    }
  },
  "en": {
    "activerecord": {
      "attributes": {
        "doorkeeper/application": {
          "name": "Name",
          "redirect_uri": "Redirect URI"
        },
        "user": {
          "sign_up_organization_name": "Organization",
          "sign_up_role": "Role"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        },
        "models": {
          "doorkeeper/application": {
            "attributes": {
              "redirect_uri": {
                "forbidden_uri": "is forbidden by the server.",
                "fragment_present": "cannot contain a fragment.",
                "invalid_uri": "must be a valid URI.",
                "relative_uri": "must be an absolute URI.",
                "secured_uri": "must be an HTTPS/SSL URI.",
                "unspecified_scheme": "must specify a scheme."
              },
              "scopes": {
                "not_match_configured": "doesn't match configured on the server."
              }
            }
          }
        }
      },
      "models": {
        "catalog": "Catalog",
        "category": "Category",
        "document": "Case",
        "document_set": "Course",
        "group": "Group"
      }
    },
    "ancestry": {
      "cannot_delete_descendants": "Cannot delete record because it has descendants.",
      "cannot_rebuild_depth_cache": "Cannot rebuild depth cache for model without depth caching.",
      "conflicting_parent_id": "Conflicting parent id found in node %{node_id}: %{parent_id} for node %{node_id} while expecting %{expected}",
      "exclude_self": "%{class_name} cannot be a descendant of itself.",
      "invalid_ancestry_column": "Invalid format for ancestry column of node %{node_id}: %{ancestry_column}.",
      "invalid_orphan_strategy": "Invalid orphan strategy, valid ones are :rootify, :adopt, :restrict and :destroy.",
      "no_child_for_new_record": "No child ancestry for new record. Save record before performing tree operations.",
      "option_must_be_hash": "Options for has_ancestry must be in a hash.",
      "reference_nonexistent_node": "Reference to nonexistent node in node %{node_id}: %{ancestor_id}.",
      "unknown_depth_option": "Unknown depth option: %{scope_name}.",
      "unknown_format": "Unknown ancestry format: %{value}.",
      "unknown_option": "Unknown option for has_ancestry: %{key} => %{value}."
    },
    "catalog": "course",
    "categories": {
      "cardiovascular": "Cardiovascular",
      "dermatology": "Dermatology",
      "eent": "EENT",
      "emergency_medicine": "Emergency Medicine",
      "endocrinology": "Endocrinology",
      "family_medicine": "Family Medicine",
      "gastroenterology": "Gastroenterology",
      "geriatrics": "Geriatrics",
      "interdisciplinary": "Interdisciplinary",
      "musculoskeletal": "Musculoskeletal",
      "nephrology": "Nephrology",
      "neurology": "Neurology",
      "nursing": "Nursing",
      "ob_gyn": "OB/GYN",
      "pediatrics": "Pediatrics",
      "physician_assistant": "Physician Assistant",
      "psychology": "Psychology",
      "pulmonology": "Pulmonology"
    },
    "category": "category",
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%B %d, %Y",
        "short": "%b %d"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about 1 hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about 1 month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about 1 year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost 1 year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than 1 second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over 1 year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "1 day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "1 minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "1 month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "1 second",
          "other": "%{count} seconds"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Seconds",
        "year": "Year"
      },
      "relative": {
        "future": "in %{time}",
        "past": "%{time} ago"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Your account was successfully confirmed.",
        "send_instructions": "You will receive an email with instructions about how to confirm your account in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions about how to confirm your account in a few minutes."
      },
      "failure": {
        "already_authenticated": "You are already signed in.",
        "inactive": "Your account is not activated yet.",
        "invalid": "Invalid email or password.",
        "last_attempt": "You have one more attempt before your account will be locked.",
        "locked": "Your account is locked.",
        "not_found_in_database": "Invalid email or password.",
        "timeout": "Your session expired. Please sign in again to continue.",
        "unauthenticated": "You need to sign in or sign up before continuing.",
        "unconfirmed": "You have to confirm your account before continuing."
      },
      "mailer": {
        "confirmation_instructions": {
          "subject": "Confirmation instructions"
        },
        "email_changed": {
          "subject": "Email Changed"
        },
        "password_change": {
          "subject": "Password Changed"
        },
        "reset_password_instructions": {
          "subject": "Reset password instructions"
        },
        "unlock_instructions": {
          "subject": "Unlock Instructions"
        }
      },
      "omniauth_callbacks": {
        "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
        "success": "Successfully authenticated from %{kind} account."
      },
      "passwords": {
        "no_token": "You can't access this page without coming from a password reset email. If you did come from a password reset email, please make sure you used the full URL provided.",
        "send_instructions": "You will receive an email with instructions on how to reset your password in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
        "updated": "Your password was changed successfully. You are now signed in.",
        "updated_not_active": "Your password was changed successfully."
      },
      "registrations": {
        "destroyed": "Bye! Your account was successfully cancelled. We hope to see you again soon.",
        "signed_up": "Welcome! You have signed up successfully.",
        "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
        "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
        "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please open the link to activate your account.",
        "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and click on the confirm link to finalize confirming your new email address.",
        "updated": "You updated your account successfully.",
        "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
      },
      "sessions": {
        "already_signed_out": "Signed out successfully.",
        "signed_in": "Signed in successfully.",
        "signed_out": "Signed out successfully."
      },
      "unlocks": {
        "send_instructions": "You will receive an email with instructions about how to unlock your account in a few minutes.",
        "send_paranoid_instructions": "If your account exists, you will receive an email with instructions about how to unlock it in a few minutes.",
        "unlocked": "Your account has been unlocked successfully. Please sign in to continue."
      }
    },
    "document": "case",
    "document_set": "collection",
    "doorkeeper": {
      "applications": {
        "buttons": {
          "authorize": "Authorize",
          "cancel": "Cancel",
          "destroy": "Destroy",
          "edit": "Edit",
          "submit": "Submit"
        },
        "confirmations": {
          "destroy": "Are you sure?"
        },
        "edit": {
          "title": "Edit application"
        },
        "form": {
          "error": "Whoops! Check your form for possible errors"
        },
        "help": {
          "blank_redirect_uri": "Leave it blank if you configured your provider to use Client Credentials, Resource Owner Password Credentials or any other grant type that doesn't require redirect URI.",
          "confidential": "Application will be used where the client secret can be kept confidential. Native mobile apps and Single Page Apps are considered non-confidential.",
          "redirect_uri": "Use one line per URI",
          "scopes": "Separate scopes with spaces. Leave blank to use the default scopes."
        },
        "index": {
          "actions": "Actions",
          "callback_url": "Callback URL",
          "confidential": "Confidential?",
          "confidentiality": {
            "no": "No",
            "yes": "Yes"
          },
          "name": "Name",
          "new": "New Application",
          "title": "Your applications"
        },
        "new": {
          "title": "New Application"
        },
        "show": {
          "actions": "Actions",
          "application_id": "UID",
          "callback_urls": "Callback urls",
          "confidential": "Confidential",
          "not_defined": "Not defined",
          "scopes": "Scopes",
          "secret": "Secret",
          "secret_hashed": "Secret hashed",
          "title": "Application: %{name}"
        }
      },
      "authorizations": {
        "buttons": {
          "authorize": "Authorize",
          "deny": "Deny"
        },
        "error": {
          "title": "An error has occurred"
        },
        "form_post": {
          "title": "Submit this form"
        },
        "new": {
          "able_to": "This application will be able to",
          "prompt": "Authorize %{client_name} to use your account?",
          "title": "Authorization required"
        },
        "show": {
          "title": "Authorization code"
        }
      },
      "authorized_applications": {
        "buttons": {
          "revoke": "Revoke"
        },
        "confirmations": {
          "revoke": "Are you sure?"
        },
        "index": {
          "application": "Application",
          "created_at": "Created At",
          "date_format": "%Y-%m-%d %H:%M:%S",
          "title": "Your authorized applications"
        }
      },
      "errors": {
        "messages": {
          "access_denied": "The resource owner or authorization server denied the request.",
          "admin_authenticator_not_configured": "Access to admin panel is forbidden due to Doorkeeper.configure.admin_authenticator being unconfigured.",
          "credential_flow_not_configured": "Resource Owner Password Credentials flow failed due to Doorkeeper.configure.resource_owner_from_credentials being unconfigured.",
          "forbidden_token": {
            "missing_scope": "Access to this resource requires scope \"%{oauth_scopes}\"."
          },
          "invalid_client": "Client authentication failed due to unknown client, no client authentication included, or unsupported authentication method.",
          "invalid_code_challenge_method": {
            "one": "The code_challenge_method must be %{challenge_methods}.",
            "other": "The code_challenge_method must be one of %{challenge_methods}.",
            "zero": "The authorization server does not support PKCE as there are no accepted code_challenge_method values."
          },
          "invalid_grant": "The provided authorization grant is invalid, expired, revoked, does not match the redirection URI used in the authorization request, or was issued to another client.",
          "invalid_redirect_uri": "The requested redirect uri is malformed or doesn't match client redirect URI.",
          "invalid_request": {
            "invalid_code_challenge": "Code challenge is required.",
            "missing_param": "Missing required parameter: %{value}.",
            "request_not_authorized": "Request need to be authorized. Required parameter for authorizing request is missing or invalid.",
            "unknown": "The request is missing a required parameter, includes an unsupported parameter value, or is otherwise malformed."
          },
          "invalid_scope": "The requested scope is invalid, unknown, or malformed.",
          "invalid_token": {
            "expired": "The access token expired",
            "revoked": "The access token was revoked",
            "unknown": "The access token is invalid"
          },
          "resource_owner_authenticator_not_configured": "Resource Owner find failed due to Doorkeeper.configure.resource_owner_authenticator being unconfigured.",
          "revoke": {
            "unauthorized": "You are not authorized to revoke this token"
          },
          "server_error": "The authorization server encountered an unexpected condition which prevented it from fulfilling the request.",
          "temporarily_unavailable": "The authorization server is currently unable to handle the request due to a temporary overloading or maintenance of the server.",
          "unauthorized_client": "The client is not authorized to perform this request using this method.",
          "unsupported_grant_type": "The authorization grant type is not supported by the authorization server.",
          "unsupported_response_mode": "The authorization server does not support this response mode.",
          "unsupported_response_type": "The authorization server does not support this response type."
        }
      },
      "flash": {
        "applications": {
          "create": {
            "notice": "Application created."
          },
          "destroy": {
            "notice": "Application deleted."
          },
          "update": {
            "notice": "Application updated."
          }
        },
        "authorized_applications": {
          "destroy": {
            "notice": "Application revoked."
          }
        }
      },
      "layouts": {
        "admin": {
          "nav": {
            "applications": "Applications",
            "home": "Home",
            "oauth2_provider": "OAuth2 Provider"
          },
          "title": "Doorkeeper"
        },
        "application": {
          "title": "OAuth authorization required"
        }
      },
      "pre_authorization": {
        "status": "Pre-authorization"
      },
      "scopes": {
        "public": "ReelDx Credentials"
      }
    },
    "errors": {
      "connection_refused": "Oops! Failed to connect to the Web Console middleware.\nPlease make sure a rails development server is running.\n",
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "already_confirmed": "was already confirmed, please try signing in",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "expired": "has expired. For security reasons the link expires 48 hours after being sent. Please request a new link by clicking the 'Request Password Reset' link at the bottom of the page and submitting your email address.",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "in": "must be in %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid. If you have requested a password reset multiple times then only the most recent link will work. Please request a new link by clicking the 'Request Password Reset' link at the bottom of the page and submitting your email address.",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "not_found": "not found",
        "not_locked": "was not locked",
        "not_saved": {
          "one": "1 error prohibited this %{resource} from being saved:",
          "other": "%{count} errors prohibited this %{resource} from being saved:"
        },
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "password_too_long": "is too long",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is 1 character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is 1 character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "wrong_length": {
          "one": "is the wrong length (should be 1 character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "unacceptable_request": "A supported version is expected in the Accept header.\n",
      "unavailable_session": "Session %{id} is no longer available in memory.\n\nIf you happen to run on a multi-process server (like Unicorn or Puma) the process\nthis request hit doesn't store %{id} in memory. Consider turning the number of\nprocesses/workers to one (1) or using a different server in development.\n"
    },
    "flash": {
      "actions": {
        "create": {
          "notice": "%{resource_name} was successfully created."
        },
        "destroy": {
          "alert": "%{resource_name} could not be destroyed.",
          "notice": "%{resource_name} was successfully destroyed."
        },
        "update": {
          "notice": "%{resource_name} was successfully updated."
        }
      }
    },
    "group": "group",
    "helpers": {
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "negative_format": "-%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB",
            "zb": "ZB"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Oops, we failed to validate your reCAPTCHA response. Please try again.",
        "verification_failed": "reCAPTCHA verification failed, please try again."
      }
    },
    "sso_only": {
      "edit": "Learner profiles are managed at %{name}",
      "roles": "Learners cannot be granted other roles if group is SSO only",
      "sign_in": "Learners must sign in and launch ReelDx at %{name}"
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "long": "%B %d, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    }
  },
  "es": {
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Ups, no pudimos validar su respuesta de reCAPTCHA. Por favor intente de nuevo.",
        "verification_failed": "La verificación de reCAPTCHA falló, por favor intente de nuevo."
      }
    }
  },
  "fr": {
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Oops, nous n'avons pas pu valider votre réponse reCAPTCHA. Veuillez essayer à nouveau.",
        "verification_failed": "La vérification reCAPTCHA a échoué, veuillez essayer à nouveau."
      }
    }
  },
  "it": {
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Ops, non siamo riusciti a convalidare la tua risposta reCAPTCHA. Per favore riprova.",
        "verification_failed": "La verifica reCAPTCHA non è riuscita, si prega di riprovare."
      }
    }
  },
  "ja": {
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "reCAPTCHAのレスポンスを検証できませんでした。もう一度お試しください。",
        "verification_failed": "reCAPTCHA認証に失敗しました。もう一度お試しください。"
      }
    }
  },
  "nl": {
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Oeps, we hebben uw reCAPTCHA-antwoord niet kunnen valideren. Probeer het opnieuw.",
        "verification_failed": "reCAPTCHA-verificatie mislukt, probeer het opnieuw."
      }
    }
  },
  "pt": {
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Oops, não conseguimos validar sua resposta do reCAPTCHA. Por favor, tente novamente.",
        "verification_failed": "A verificação do reCAPTCHA falhou, por favor, tente novamente."
      }
    }
  },
  "pt-BR": {
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Oops, não conseguimos validar sua resposta do reCAPTCHA. Por favor, tente novamente.",
        "verification_failed": "A verificação do reCAPTCHA falhou, por favor, tente novamente."
      }
    }
  }
}